module.exports = __webpack_public_path__ + "media/images/members/santiago_fernandez_mosquera-b88ac29e6ecb73c7ab49d133ef5b5028.jpg";